import React, { useEffect, useState } from 'react';
import CustomSelect from '../../components/common/CustomSelect';
import { DepartmentEnum } from '../Enum/DepartmentEnum';
import TeamService from '../Services/TeamService';
import { showErrorToast } from '../../components/Constant/Notification';

const UserFilter = ({ selectedFilters, setSelectedFilters, onApplyFilters, onClearFilters }) => {
  const [teamOptions, setTeamOptions] = useState([]);

  useEffect(() => {
    const fetchTeamName = async () => {
      try {
        const response = await TeamService.getDepartmentTeamList({
          department: selectedFilters.department?.label,
        });
        console.log("Team Response:", response);
        if (response.data) {
          const teamNames = response.data;
          setTeamOptions(teamNames);
        }
      } catch (error) {
        console.error("Error fetching team names:", error);
      }
    };
    fetchTeamName();
  }, [selectedFilters.department]);

  const handleApplyFilters = () => {
    if(!selectedFilters.department || !selectedFilters.team) {
      showErrorToast("Please select both Department and Team");
      return;
    }
    onApplyFilters({
      department: selectedFilters.department,
      team: selectedFilters.team,
    });
  };

  const handleClearFilters = () => {
    setSelectedFilters({ department: null, team: null });
    onClearFilters();
  };

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-4">
        <CustomSelect
          options={DepartmentEnum}
          placeholder="Select Department"
          value={selectedFilters.department}
          onChange={(value) => setSelectedFilters((prev) => ({ ...prev, department: value }))}
        />
        <CustomSelect
          options={teamOptions}
          disabled={!selectedFilters.department}
          placeholder="Select Team"
          value={selectedFilters.team}
          onChange={(value) => setSelectedFilters((prev) => ({ ...prev, team: value }))}
        />
      </div>
      <div className="flex flex-col gap-4">
        <button
          className="bg-customGreen text-white px-4 py-2 rounded-md transition-colors"
          onClick={handleApplyFilters}
        >
          Apply Filters
        </button>
        <button
          className="bg-gray-300 text-red-500 px-4 py-2 rounded-md transition-colors"
          onClick={handleClearFilters}
        >
          Clear Filters
        </button>
      </div>
    </div>
  );
};

export default UserFilter;